import { Box, Chip, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { confirm } from "lib/@dialogs/confirm"
import { errorSnackbar } from "lib/snackbar/error-snackbar"
import { successSnackbar } from "lib/snackbar/success-snackbar"
import { invalidate } from "lib/graphql/cache"
import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { revokeScimToken } from "routes/settings/plugins/scim/controller/revoke-scim-token"
import { If } from "lib/@components/switch"

export function TokenRow({ token }) {
    const { client } = useBoundContext()
    const clientId = client?.id
    const isRevoked = !!token.revokedAt

    return (
        <Box
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                gap: 2,
                p: 2,
                border: 1,
                borderColor: "divider",
                borderRadius: 1,
                opacity: isRevoked ? 0.6 : 1,
            }}
        >
            <Stack spacing={0.5} sx={{ minWidth: 0 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                        {token.prefix}…
                    </Typography>
                    <If value={isRevoked}>
                        <Chip size="small" label="Revoked" color="default" />
                    </If>
                </Stack>
                <Typography variant="caption" color="text.secondary">
                    Created {formatDate(token.createdAt)} by {token.createdBy || "unknown"}
                    {token.lastUsedAt ? ` • last used ${formatDate(token.lastUsedAt)}` : " • never used"}
                    {token.note ? ` • ${token.note}` : ""}
                </Typography>
            </Stack>
            <If value={!isRevoked}>
                <Tooltip title="Revoke token">
                    <IconButton onClick={revoke} size="small">
                        <Iconify icon="mdi:key-remove" />
                    </IconButton>
                </Tooltip>
            </If>
        </Box>
    )

    async function revoke() {
        const ok = await confirm(
            `Revoke token ${token.prefix}…? Your IdP will stop being able to provision users until a replacement token is configured.`,
            "Revoke SCIM token"
        )
        if (!ok) return
        try {
            await revokeScimToken({ id: token._id, clientId })
            invalidate("getScimTokens")
            successSnackbar("Token revoked")
        } catch (error) {
            console.error(error)
            errorSnackbar(error?.message || "Failed to revoke token")
        }
    }
}

function formatDate(iso) {
    if (!iso) return "—"
    return new Date(iso).toLocaleString()
}
